import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix More icon — three vertically stacked dots (stroked outlines).
 * Dots share one centre line at x=10 with even 5.286 spacing about y=10, so the glyph
 * sits on the same optical centre as the other 20-box action icons it lines up with.
 * Uses `stroke="currentColor"` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const MoreIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <circle cx="10" cy="4.71387" r="1.45116" stroke="currentColor" />
    <circle cx="10" cy="10" r="1.45116" stroke="currentColor" />
    <circle cx="10" cy="15.28613" r="1.45116" stroke="currentColor" />
  </svg>
);

export default MoreIcon;
